export default "__VITE_ASSET__BqAy3YQJ__"